import Auth from "./Auth";
import Home from "./pages/Home";
import Services from "./pages/Services/index";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Doctors from "./pages/Doctors";
import Admin from "./Admin";

export const publicRoutes = [
    {
        path: "/auth",
        Component: Auth
    },
    {
        path: "/login",
        Component: Auth
    },
    {
        path: "/registration",
        Component: Auth
    },
    { path: "/", Component: Home },
    { path: "/about", Component: About },
    { path: "/services", Component: Services },
    { path: "/contact", Component: Contact },
    { path: "/doctor", Component: Doctors },
]

export const authRoutes = [
    
]

export const adminRoutes = [
    {
        path: "/admin",
        Component: Admin
    },
    // {
    //     path: ADMIN_ROUTE+'/add_product',
    //     Component: AddProductPage
    // },
    // {
    //     path: ADMIN_ROUTE+'/add_brand',
    //     Component: AddBrandPage
    // },
    // {
    //     path: ADMIN_ROUTE+'/add_category',
    //     Component: AddCategoryPage
    // },
]
